import { Box, Typography } from '@mui/material';
import React from 'react';
import TwField, { TwInputTypes } from '../../../../../components/TwFields/TwFields';
import { IOtherCompanies } from '../../../../../redux/api/factoring/factoring.model';
import TwCheckbox from '../../../../../components/TwCheckboxes/TwCheckboxes';

interface OtherCompaniesProps {
  factoringData: IOtherCompanies;
  sendAllInvoices: boolean;
  handleFactoringData: (data: IOtherCompanies, sendByDefault: boolean) => void;
}

const OtherCompanies: React.FC<OtherCompaniesProps> = ({
  factoringData,
  sendAllInvoices,
  handleFactoringData
}): JSX.Element => {
  return (
    <>
      <Box className="factoring__details">
        <Typography variant="subtitle2" fontWeight="600" fontSize="14px">
          How to add details
        </Typography>
        <Typography variant="subtitle2" fontWeight="400" fontSize="14px" lineHeight="24px">
          When setting up a new factoring company in Truckbase, you’ll be able to add a notice of
          assignment to factored invoices and easily email invoices & documents to your factoring
          company via email. If you’d a direct integration, please ask your factoring company if
          they support FTP integrations and we’d be happy to assist with getting that set up!
        </Typography>
      </Box>
      <div className="tid-factoring__details__company-name">
        <TwField
          id="companyName"
          name="companyName"
          value={factoringData.company}
          label="Company name"
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            handleFactoringData({ ...factoringData, company: e.target.value }, sendAllInvoices);
          }}
        />
      </div>
      <div className="tid-factoring__details__company-email">
        <TwField
          id="companyEmail"
          name="companyEmail"
          value={factoringData.company_email as string}
          label="Company email"
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            handleFactoringData(
              { ...factoringData, company_email: e.target.value },
              sendAllInvoices
            );
          }}
        />
      </div>
      <div className="tid-factoring__details__company-address">
        <TwField
          id="companyAddress"
          name="companyAddress"
          value={factoringData.company_address as string}
          label="Company address"
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            handleFactoringData(
              { ...factoringData, company_address: e.target.value },
              sendAllInvoices
            );
          }}
        />
      </div>
      <TwCheckbox
        name="sendAllInvoices"
        value="sendAllInvoices"
        label="Send all invoices to factoring by default"
        checked={sendAllInvoices}
        onInputChange={(e): void => {
          handleFactoringData(factoringData, e.target.checked);
        }}
      />
    </>
  );
};

export default OtherCompanies;
